import { render, staticRenderFns } from "./studyData.vue?vue&type=template&id=7a7c571f&scoped=true&"
import script from "./studyData.vue?vue&type=script&lang=js&"
export * from "./studyData.vue?vue&type=script&lang=js&"
import style0 from "./studyData.vue?vue&type=style&index=0&id=7a7c571f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c571f",
  null
  
)

export default component.exports